// Simple in-memory + localStorage-backed notification store
const STORAGE_KEY = "appNotifications";

let listeners = [];
let notifications = [];

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    notifications = raw ? JSON.parse(raw) : [];
  } catch {
    notifications = [];
  }
};

const save = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
  } catch {
    // ignore quota errors
  }
};

const notify = () => {
  listeners.forEach((cb) => {
    try {
      cb([...notifications]);
    } catch {
      // ignore listener errors
    }
  });
};

load();

export const subscribeNotifications = (callback) => {
  listeners.push(callback);
  // immediate push
  callback([...notifications]);
  return () => {
    listeners = listeners.filter((cb) => cb !== callback);
  };
};

export const addNotification = (note) => {
  try {
    // helpful debug
    // eslint-disable-next-line no-console
    console.log("➕ addNotification", note);
  } catch {}
  const item = {
    title: note.title || "New Notification",
    desc: note.desc || note.body || "You have a new message",
    time: note.time || new Date().toLocaleTimeString(),
  };
  notifications = [item, ...notifications].slice(0, 100); // cap
  save();
  notify();
};

export const getNotifications = () => {
  return [...notifications];
};

export const clearNotifications = () => {
  notifications = [];
  save();
  notify();
};

